// extracted by mini-css-extract-plugin
module.exports = {"container":"_3DRTW","contentContainer":"_1jDWR","search":"_3Nh1P","block":"_2ArpK","inviteButton":"_2PZ67","hidden":"_1DgTF"};